import { createElement, Fragment } from 'react';
import { node, bool, element, shape, string, object } from 'prop-types';
import '../types/props.js';
import { withTheme } from 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import 'reakit';
import 'reakit/Portal';
import '../Portal/styled.js';
import '../Portal/index.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import 'reakit/Backdrop';
import '../Backdrop/styled.js';
import '../Backdrop/index.js';
import '../chunk-5c9bbccf.js';
import 'focus-trap';
import '../chunk-abb87050.js';
import '../Container/styled.js';
import '../chunk-cfb51aee.js';
import '../Container/index.js';
import 'react-media';
import PageContainer from './PageContainer.js';
import 'reakit/Sidebar';
import '../Sidebar/SidebarContainer.js';
import '../Sidebar/styled.js';
import '../Sidebar/SidebarClose.js';
import '../Sidebar/SidebarHide.js';
import '../Sidebar/SidebarShow.js';
import { b as sidebarPropTypes } from '../chunk-3ccbd0d4.js';
import '../Sidebar/index.js';
import { PageWithSidebar as PageWithSidebar$1, Spacer, MobileSidebarWrapper, Sidebar, DesktopSidebarWrapper } from './styled.js';
import _merge from 'lodash/merge';

var PageWithSidebar = function PageWithSidebar(_ref) {
  var children = _ref.children,
      _hideSidebarOnDesktop = _ref.hideSidebarOnDesktop,
      sidebarContent = _ref.sidebarContent,
      _sidebarProps = _ref.sidebarProps,
      _sidebarWidth = _ref.sidebarWidth,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "hideSidebarOnDesktop", "sidebarContent", "sidebarProps", "sidebarWidth", "theme"]);

  var defaultProps = _get(theme, 'fannypack.Page.WithSidebar.defaultProps', {});

  var hideSidebarOnDesktop = _hideSidebarOnDesktop || defaultProps.hideSidebarOnDesktop;

  var sidebarProps = _merge(_sidebarProps, defaultProps.sidebarProps);

  var sidebarWidth = _sidebarWidth || defaultProps.sidebarWidth;
  return createElement(PageContainer, null, function (page) {
    return createElement(PageWithSidebar$1, props, createElement(Spacer, {
      hideSidebarOnDesktop: hideSidebarOnDesktop,
      isMinimized: page.isMinimized,
      isVisible: page.isSidebarOpen,
      sidebarWidth: sidebarWidth
    }), page && page.isCollapsed ? // @ts-ignore
    createElement(MobileSidebarWrapper, _extends({}, sidebarProps, {
      isVisible: page.isSidebarOpen,
      onClickClose: page.closeSidebar,
      hide: page.closeSidebar,
      width: sidebarWidth
    }), createElement(Sidebar, {
      sidebarWidth: sidebarWidth
    }, sidebarContent)) : createElement(Fragment, null, !hideSidebarOnDesktop && createElement(DesktopSidebarWrapper, {
      isVisible: page.isSidebarOpen
    }, createElement(Sidebar, {
      isMinimized: page.isMinimized,
      sidebarWidth: sidebarWidth
    }, sidebarContent))), createElement(Box, {
      width: "100%"
    }, typeof children === 'function' ?
    /*
    // @ts-ignore */
    children({
      page: page
    }) : children));
  });
};

var PageWithSidebarPropTypes = {
  children: node.isRequired,
  hideSidebarOnDesktop: bool,
  sidebarContent: element.isRequired,
  sidebarProps: shape(sidebarPropTypes),
  sidebarWidth: string,
  theme: object
};
PageWithSidebar.propTypes = PageWithSidebarPropTypes;
var PageWithSidebarDefaultProps = {
  hideSidebarOnDesktop: false,
  sidebarProps: {},
  sidebarWidth: '250px',
  theme: {}
};
PageWithSidebar.defaultProps = PageWithSidebarDefaultProps;
var C = withTheme(PageWithSidebar);
export default C;
export { PageWithSidebar, PageWithSidebarDefaultProps, PageWithSidebarPropTypes };